<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px" :disabled="detailType=='details'">
      <el-form-item label="角色名称" prop="roleName" style="margin-right:15px">
        <el-input v-model="form.roleName" placeholder="请输入角色名称" />
      </el-form-item>
      <el-form-item label="备注" prop="description" style="margin-right:15px">
        <el-input v-model="form.description" placeholder="请输入备注" />
      </el-form-item>
    </el-form>
    <div v-if="detailType!='details'" slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          partyCode: "",
          branchCode: "",
        };
      },
    },
  },
  data() {
    return {
      detailType: "add",
      form: {
        roleName: "",
        description: "",
      },
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
      },
    };
  },
  created() {},
  methods: {
    // 获取页面信息
    getInfo(detailType, code) {
      this.detailType = detailType;
      this.$refs["form"].resetFields();
      if (code) {
        // 查询总数
        request({ url: `/ntocc-basic-api/role/${code}`, method: "get" }).then(
          (response) => {
            this.form = response.data;
          }
        );
      }
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          let data = this.form;
          data.shipmentCode = this.parentData.partyCode;
          data.branchCode = this.parentData.branchCode;
          let method = this.detailType == "add" ? "post" : "put";
          request({
            url: "/ntocc-basic-api/role",
            method: method,
            params: data,
          })
            .then((response) => {
              rLoading.close();
              this.form={
                 roleName: "",
                 description: "",
              }//清空数据
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
